import { Grid as GridV6 } from "@mui/material";

/**
 * Compatibility wrapper for MUI Grid v7
 * Supports legacy props:
 * - container
 * - item (ignored in v7 but accepted for backward compatibility)
 * - xs, sm, md, lg, xl
 * - spacing
 */
const Grid = ({
  container,
  item, // deprecated, but accepted
  spacing,
  xs,
  sm,
  md,
  lg,
  xl,
  children,
  ...rest
}) => {
  // Build v7 `size` prop from legacy breakpoint props
  let size;

  if (xs || sm || md || lg || xl) {
    size = {
      ...(xs !== undefined && { xs }),
      ...(sm !== undefined && { sm }),
      ...(md !== undefined && { md }),
      ...(lg !== undefined && { lg }),
      ...(xl !== undefined && { xl }),
    };
  }

  return (
    <GridV6
      container={container}
      spacing={container ? spacing : undefined}
      size={size}
      {...rest}
    >
      {children}
    </GridV6>
  );
};

export default Grid;
